export default __webpack_public_path__ + "static/media/brave_zone_background_s1.6fcd1385.jpg";